import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames, fCredit, fDate } from '@aibees/shared/utils';
import { Divider, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ImportantNoteProps as Props } from './types';

export const ImportantNote = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();

  return (
    <Styled.Wrapper
      className={classnames('ImportantNote', className)}
      sx={SX.root}
    >
      <Typography variant="body3" color="grey.700">
        Important Note
      </Typography>
      <Divider sx={SX.divider} />
      <Typography variant="body4" fontWeight={400}>
        Please note that on {fDate(data?.current?.currentPeriodEnd)}, your
        credit balance will be capped at {data?.next?.plan?.metadata.rollover}{' '}
        credits.
      </Typography>
      <br />
      <Typography variant="body4" fontWeight={400}>
        You currently have{' '}
        <Typography variant="body4" fontWeight={700} component="span">
          {fCredit(data?.credit?.total ?? 0)} Credits
        </Typography>{' '}
        , which means{' '}
        <Typography variant="body4" fontWeight={700} component="span">
          {fCredit(data?.credit?.total ?? 0)} Credits
        </Typography>{' '}
        will be lost if not used before the downgrade takes effect.
      </Typography>
    </Styled.Wrapper>
  );
});

ImportantNote.displayName = 'ImportantNote';
